import React from "react";
import CartFooter from "./CartFooter";
import CartBody from "./CartBody";

const Cart = () => {
  return (
    <div className="col-span-12 sm:col-span-12 md:col-span-5 lg:col-span-4 xxl:col-span-4">
      <CartBody />
      <CartFooter />
    </div>
  );
};

export default Cart;
